import { Injectable, OnDestroy } from '@angular/core';
import { AbstractCRUDService } from '@campaign-portal/components-library';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { EntityField, InputComplexType, InputType } from '@campaign-portal/namespace/common/entityField';
import { ReadResponse } from '@campaign-portal/namespace/common/implementations';
import { FilterType } from '@campaign-portal/namespace/common/rpc.params';

@Injectable({ providedIn: 'root' })
export class CamaraRulesFieldsService implements AbstractCRUDService, OnDestroy {
	readonly id: EntityField = {
		id: 0,
		name: 'camara_rules.id',
		variable: 'id',
		filterType: FilterType.LIKE,
		required: false,
		type: InputType.TEXT,
	};
	readonly ruleType: EntityField = {
		id: 1,
		name: 'camara_rules.rule_type',
		variable: 'ruleType',
		filterType: FilterType.LIKE,
		required: false,
		type: InputComplexType.MULTISELECT,
		data: [],
	};
	readonly client: EntityField = {
		id: 2,
		name: 'camara_rules.client',
		variable: 'clientList',
		filterType: FilterType.LIKE,
		required: false,
		type: InputComplexType.MULTISELECT,
		data: [],
	};
	readonly prefix: EntityField = {
		id: 3,
		name: 'camara_rules.prefix',
		variable: 'prefixList',
		filterType: FilterType.LIKE,
		required: false,
		type: InputType.TEXT,
	};
	readonly source: EntityField = {
		id: 4,
		name: 'camara_rules.source',
		variable: 'source',
		filterType: FilterType.LIKE,
		required: false,
		type: InputComplexType.MULTISELECT,
		data: [],
	};
	readonly createdBy: EntityField = {
		id: 5,
		name: 'camara_rules.created_by',
		variable: 'createdBy',
		filterType: FilterType.LIKE,
		required: false,
		type: InputComplexType.MULTISELECT,
		data: [],
	};
	readonly lastUpdated: EntityField = {
		id: 6,
		name: 'camara_rules.last_updated',
		variable: 'lastUpdated',
		filterType: FilterType.BETWEEN,
		required: false,
		type: InputComplexType.DATE_RANGE,
	};

	readonly entity = '';
	readonly title = '';
	readonly loading$ = new BehaviorSubject<boolean>(false);
	readonly headers: EntityField[] = [
		this.id,
		this.ruleType,
		this.client,
		this.prefix,
		this.source,
		this.createdBy,
		this.lastUpdated
	];

	constructor() {}

	ngOnDestroy(): void {
		this.loading$.complete();
	}

	read(): Observable<ReadResponse<EntityField[]>> {
		return of({ Success: true, Total: this.headers.length, Data: this.headers });
	}

	create(): Observable<void> {
		return of();
	}
	update(): Observable<void> {
		return of();
	}
	delete(): Observable<void> {
		return of();
	}
}